import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('add_new_currency'),
    description: defineMessage('select_which_currencies__to_add_to_your_wallets'),
    confirmationTitle: defineMessage('confirmation'),
    confirmationDescription: defineMessage('we_will_create_new_bank_he_following_currencies'),
    confirmationConfirmButton: defineMessage('create'),
    confirmationCancelButton: defineMessage('cancel'),
    currency: defineMessage('currency'),
    currencyPlaceholder: defineMessage('select_currency'),
    add: defineMessage('add'),
};
